export var IdAssetBundleProductionAnims;
(function (IdAssetBundleProductionAnims) {
    IdAssetBundleProductionAnims["Chicken"] = "chicken";
    IdAssetBundleProductionAnims["Cow"] = "cow";
    IdAssetBundleProductionAnims["Dog"] = "dog";
    IdAssetBundleProductionAnims["Duck"] = "duck";
    IdAssetBundleProductionAnims["Goat"] = "Goat_big";
    IdAssetBundleProductionAnims["Goaty"] = "Goaty";
    IdAssetBundleProductionAnims["Pig"] = "pig";
    IdAssetBundleProductionAnims["Boy"] = "boy";
    IdAssetBundleProductionAnims["Girl"] = "girl";
    IdAssetBundleProductionAnims["Man"] = "man";
    IdAssetBundleProductionAnims["Woman"] = "woman";
    IdAssetBundleProductionAnims["WindmillBlades"] = "windmill_blades";
    IdAssetBundleProductionAnims["MarketTruck"] = "market_truck";
    IdAssetBundleProductionAnims["MarketTruckDustTrail"] = "dust_trail";
    IdAssetBundleProductionAnims["BuildingCelebration3x3"] = "building_celebration_3x3";
    IdAssetBundleProductionAnims["BuildingCelebration3x6"] = "building_celebration_3x6";
    IdAssetBundleProductionAnims["BuildingCelebration6x6"] = "building_celebration_6x6";
    IdAssetBundleProductionAnims["BuildingCelebration6x9"] = "building_celebration_6x9";
    IdAssetBundleProductionAnims["BuildingCelebration9x9"] = "building_celebration_9x9";
})(IdAssetBundleProductionAnims || (IdAssetBundleProductionAnims = {}));



//////////////////
// WEBPACK FOOTER
// ./src/assetBundles/IdAssetBundleProductionAnims.ts
// module id = 809
// module chunks = 3